import { render, staticRenderFns } from "./SquareIcon.vue?vue&type=template&id=0ae083a0&scoped=true&"
import script from "./SquareIcon.vue?vue&type=script&lang=ts&"
export * from "./SquareIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SquareIcon.vue?vue&type=style&index=0&id=0ae083a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae083a0",
  null
  
)

export default component.exports